module.exports = __webpack_public_path__ + "media/img/Scholarships2u-logo-6367ecd7c3d6d60a46c25bb987959368.png";